// firstModule — resolve o primeiro módulo navegável de um highlight da home.
// Antes, Home chamava link(slug) e Universe fazia s.modules[0]?.id direto.
// As duas versões quebravam quando o highlight era uma seção sem módulos de
// primeiro nível (só subseções) — gerando href "/s/x/undefined" que leva pra
// uma página em branco. Essa função cobre os dois casos de uma vez.

export interface Highlight {
  slug?: string;
  modules?: Array<{ id?: string }>;
  subsections?: Array<{ slug?: string; modules?: Array<{ id?: string }> }>;
}

export function firstModuleHref(highlight: Highlight | null | undefined): string | null {
  if (!highlight?.slug) return null;
  const direct = highlight.modules?.[0]?.id;
  if (direct) return `/s/${highlight.slug}/${direct}`;
  for (const sub of highlight.subsections || []) {
    const first = sub.modules?.[0]?.id;
    if (first && sub.slug) return `/sb/${highlight.slug}/${sub.slug}/${first}`;
  }
  return null;
}
